import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import classNames from "classnames";
import React from "react";
import CustomTooltip from "./CustomTooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '28px'

  },
}));

const CustomButton = (props) => {
  const { btnText, btnStyle, toolTipTitle } = props;
  const classes = useStyles();
  return (
    <CustomTooltip title = {toolTipTitle} >
      <Button
        className={classNames(classes.root, props.newClassName)}
        fullWidth
        style={btnStyle}
        {...props}
        >
        {btnText}
      </Button>
    </CustomTooltip>
  );
};

export default CustomButton;
